import { render, staticRenderFns } from "./editVoice.vue?vue&type=template&id=1ce01d3c&scoped=true"
import script from "./editVoice.vue?vue&type=script&lang=js"
export * from "./editVoice.vue?vue&type=script&lang=js"
import style0 from "./editVoice.vue?vue&type=style&index=0&id=1ce01d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce01d3c",
  null
  
)

export default component.exports